module.exports = __webpack_public_path__ + "img/bg_zn.d4e33610.jpg";